import { render } from "./SiteFooter.vue?vue&type=template&id=317e740c&scoped=true"
import script from "./SiteFooter.vue?vue&type=script&lang=js"
export * from "./SiteFooter.vue?vue&type=script&lang=js"

import "./SiteFooter.vue?vue&type=style&index=0&id=317e740c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/rights.tokyo/rights.tokyo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-317e740c"]])

export default __exports__